import { Environment, getEnvFromDomainName, isValidEnv } from './utils';
import { getAuthEnv } from './getAuthEnv';
import { getBiwApiEnv } from './getBiwApiEnv';
import { getGraphqlEnv } from './getGraphqlEnv';
import { getCmxEnv } from './getCmxEnv';
import { getBunchballEnv } from './getBunchballEnv';

export * from './utils';

/**
 * The environment that the application is found to be running in. Note
 * that this environment value may not necessarily be considered a valid
 * environment (dev, qa, pprd, prod).
 * 
 * To temporarily simulate the site running on other environments, modify
 * this value. The other endpoint environments will automatically adjust
 * to attempt to match the application environment as closely as possible.
 */
export const APP_ENV = getEnvFromDomainName( window.location.hostname ); // Environment.QA

export const AUTH_ENV = getAuthEnv( APP_ENV );
export const BIW_API_ENV = getBiwApiEnv( APP_ENV );
export const GRAPHQL_ENV = getGraphqlEnv( APP_ENV );
export const CMX_ENV = getCmxEnv( APP_ENV );
export const COURSE_SERVICE_ENV = isValidEnv( GRAPHQL_ENV ) ? GRAPHQL_ENV : Environment.QA;
export const BUNCHBALL_ENV = getBunchballEnv( APP_ENV );